<template>
  <section class="studio-evaluation">
    <template v-if="detail.id">
      <mall-panel class="spu-info">
        <mall-media-info :pic="detail.spuInfo.banner_img[0]" :title="detail.spuInfo.name" :desc="detail.spuInfo.description.desc" />
      </mall-panel>

      <mall-panel class="evaluation-info">
        <div class="total">
          <van-rate
            v-model="totalStar"
            :size="36"
            color="#ffce00"
            void-icon="star"
            void-color="#dddddd"
          />
        </div>

        <ul class="other">
          <li>
            <div class="hd">
              服务态度
            </div>
            <div class="bd">
              <van-rate
                v-model="attitudeStar"
                :size="21"
                color="#ffce00"
                void-icon="star"
                void-color="#dddddd"
              />
            </div>
          </li>
          <li>
            <div class="hd">
              服务速度
            </div>
            <div class="bd">
              <van-rate
                v-model="speedStar"
                :size="21"
                color="#ffce00"
                void-icon="star"
                void-color="#dddddd"
              />
            </div>
          </li>
          <li>
            <div class="hd">
              作品满意度
            </div>
            <div class="bd">
              <van-rate
                v-model="approvingStar"
                :size="21"
                color="#ffce00"
                void-icon="star"
                void-color="#dddddd"
              />
            </div>
          </li>
        </ul>

        <div class="text">
          <p>满足你的期待吗？说说服务中需要改进的地方，帮助我们做的更好吧～</p>
          <textarea v-model="comment"></textarea>
        </div>
      </mall-panel>

      <mall-fixed-button-bar text="提交" @click="save" />
    </template>
  </section>
</template>

<script>
import MallPanel from '@cdn_js/studio/components/Panel';
import MallMediaInfo from '@cdn_js/studio/components/MediaInfo';
import MallFixedButtonBar from '@cdn_js/studio/components/FixedButtonBar';

export default {
  name: 'StudioEvaluation',

  components: {
    MallPanel,
    MallMediaInfo,
    MallFixedButtonBar
  },

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      detail: {},
      totalStar: 0,
      attitudeStar: 0,
      speedStar: 0,
      approvingStar: 0,
      comment: '',
      alterNumber: 0
    }
  },

  created() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicStore/musicmall/getOrderInfo', {
        data: {
          id: this.id,
          idType: 'order'
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.detail = data;
      }
    },

    async save() {
      if (this.totalStar < 1) {
        this.$toast.fail('请选择整体评价');
        return;
      }

      this.$toast.loading();

      const { code, msg } = await this.$fetch('/api/musicStore/musicmall/orderEvaluation', {
        method: 'post',
        data: {
          orderid: this.id,
          comment: this.comment,
          total: this.totalStar,
          attitude: this.attitudeStar,
          speed: this.speedStar,
          approving: this.approvingStar,
          publish_comment: this.$route.query.publish_comment === 'yes' ? 1 : 0
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.$toast.success('提交成功');
        this.$router.push(`/studio/order/${this.id}`);
      }
      else {
        this.$toast.fail(msg);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/evaluation.scss";
</style>
